import * as React from 'react';
import { Alert } from '../../../../../components/common/alert';
import { Flex } from '../../../../../components/common/flex';
import { Done } from '../../../../../components/icons';
import { PERFORMED_ACTION_MESSAGES } from '../../lib/performed_action_messages';
import { IBookActionPerformedProps } from './book_action_performed.d';

export const BookActionPerformed: React.FC<IBookActionPerformedProps> = ({ action, reasons = [] }) => {
  return (
    <Flex vertical gap={20} className={'approve-book-section'}>
      <h2 className={'approve-book-section__title typography-h2'}>Спасибо!</h2>
      <div className={'approve-book-section__container'}>
        <Alert
          title={PERFORMED_ACTION_MESSAGES[action]}
          icon={<Done />}
          status={action == 'approve' ? 'success' : 'info'}
          size={'large'}
        />
      </div>
      {action != 'approve' && (
        <Flex vertical gap={12} className={'approve-book-section__container'}>
          <span>{action == 'correct' ? 'Причины корректировки' : 'Причина отказа'}:</span>
          {action == 'correct' ? (
            <Flex vertical gap={'small'} component={'ul'}>
              {reasons.map((reason, index) => (
                <li key={index}>{reason}</li>
              ))}
            </Flex>
          ) : (
            <span>{reasons[0]}</span>
          )}
        </Flex>
      )}
    </Flex>
  );
};
